
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiConnectorCrossJoint as ObiConnectorCrossJointElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-connector-cross-joint.js';
 
 
 

 
 export const ObiConnectorCrossJoint = createComponent({
   react: React,
   tagName: 'obi-connector-cross-joint',
   elementClass: ObiConnectorCrossJointElement,
   events: {
     
   }
  });
 
 